import { IonContent } from '@ionic/angular';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ENV_CONFIG } from 'src/bin/env.config';
import { PhotoModel } from '../booking-photos-manager/booking-photos-manager.component';
import { ClientService } from 'src/app/services';
import { Utilities } from '../../utilities/utilities';
import {
  AlertController,
  LoadingController,
  Platform,
  ModalController,
} from '@ionic/angular';
import { Client } from '../../models';
@Component({
  selector: 'smr-booking-photos',
  templateUrl: './booking-photos.component.html',
  styleUrls: ['./booking-photos.component.scss'],
})
export class BookingPhotosComponent implements OnInit {
  @Input() client: Client;

  @Input() clientPhotos;

  @Input() content: IonContent;
  @Input() isReadOnly: boolean = false;
  @Output() viewPhoto = new EventEmitter<PhotoModel>();
  @Output() profilePhoto = new EventEmitter<string>();

  public BOOKING_PHOTO_ROOT: string;

  public THUMBNAIL_PHOTO_ROOT: string;

  constructor(
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public clientService: ClientService,
    public platform: Platform,
    public modalCtrl: ModalController
  ) {
    this.BOOKING_PHOTO_ROOT = ENV_CONFIG.BOOKING_PHOTO_ROOT;
    this.THUMBNAIL_PHOTO_ROOT = ENV_CONFIG.THUMBNAIL_PHOTO_ROOT;
  }

  public ngOnInit() {}

  public onViewPhoto(photo: PhotoModel) {
    this.viewPhoto.emit(photo);
  }

  setProfilePhoto(profilePhoto: string) {
    this.client.setProfilePhoto(profilePhoto);
    this.profilePhoto.emit(profilePhoto);
  }

  onDeletePhoto(photoID: number) {
    this.clientPhotos = this.clientPhotos.filter(
      (photo) => photo.id !== photoID
    );
  }

  public async onImageSelect(event) {
    const avaiableFileTyoes = ['image/gif', 'image/png', 'image/jpeg'];
    const file = event.target.files[0];
    if (!avaiableFileTyoes.includes(file.type)) {
      const alert = await this.alertCtrl.create({
        header: 'Sorry, we were unable to use that image.',
        message:
          'Please use a .jpg, .gif or .png file and contact our support if you continue to enouter issues.',
        buttons: [
          {
            text: 'OK',
            role: 'dismiss',
          },
        ],
      });
      alert.present();
      return;
    }
    var reader = new FileReader();
    reader.onload = this.selectBooking.bind(this);

    reader.readAsBinaryString(file);
  }

  async selectBooking(readerEvt) {
    this.imageUpload(readerEvt);
  }

  async imageUpload(readerEvt) {
    var base64textString = btoa(readerEvt.target.result);
    const photo = 'data:image/jpeg;base64,' + base64textString;

    const loader = await this.loadingCtrl.create({ spinner: 'crescent' });
    loader.present();

    this.clientService.insertClientPhoto(this.client.id, photo).subscribe({
      next: (res) => {
        this.clientService.loadClientPhotos(this.client.id).subscribe(data =>{
          this.clientPhotos = data
          this.clientPhotos.sort((a,b) => {return new Date(b.date).getTime() - new Date(a.date).getTime()});
        })
        loader.dismiss();
      },
      error: async (err) => {
        loader.dismiss().then(async () => {
          const alert = await this.alertCtrl.create(
            Utilities.getDefaultErrorMessageConfig()
          );
          alert.present();
        });
      },
    });
  }
}
